<template>
    <a-date-picker
        :value="modelValue"
        @change="onChange"
        class="appearance-none block w-full"
        placeholder="yyyy-mm-dd"
        format="YYYY-MM-DD"
        :disabled-date="disabledDate"
        :disabled="disabled"
    />
</template>

<script>
export default {
    props: {
        modelValue: Object,
        disableDateFunction: {
            type: Function,
            default: () => {},
        },
        disabled: false,
    },
    methods: {
        onChange(date, date_string) {
            let date_object = this.$dayjs(date_string, 'YYYY-MM-DD');

            if (!date_object.isValid()) {
                date_object = null;
            }

            this.$emit('update:modelValue', date_object);
            this.$emit('changeDate');
        },
        disabledDate(current) {
            return this.disableDateFunction(current);
        },
    },
};
</script>
